import { Col, Row } from "antd";
import moment from "moment";
import React from "react";

const IncomeStaffTime = ({ record }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  if (record) {
    const time = moment(record?.bookingAt?.toDate()).format(
      "DD/MM/YYYY - HH:mm A"
    );
    return (
      <Col span={24}>
        <Row justify="space-between">
          <Col>Created time:</Col>
          <Col>{time}</Col>
        </Row>
      </Col>
    );
  }
  return null;
};
export default IncomeStaffTime;
